import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import trim from 'lodash/trim';
import compact from 'lodash/compact';
import './Avatar.css';

const propTypes = {
  bgColor: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.number,
  isBusiness: PropTypes.bool,
};

const defaultProps = {
  bgColor: '#48b0f7',
  name: '',
  size: 32,
  isBusiness: false,
};

class Avatar extends PureComponent {
  get initials() {
    const { name, isBusiness } = this.props;
    if (name) {
      if (isBusiness) {
        return name.toUpperCase().slice(0, 2);
      } else {
        return compact(
          name
            .split(' ')
            .map((name) => trim(name)[0] && trim(name)[0].toUpperCase())
        )
          .slice(0, 2)
          .join('');
      }
    } else {
      return null;
    }
  }

  render() {
    const { bgColor, name, size, style, className, ...otherProps } = this.props;
    const styles = {
      backgroundColor: bgColor,
      borderRadius: `${size}px`,
      fontSize: `${Math.round(size * 0.4)}px`,
      height: `${size}px`,
      width: `${size}px`,
      ...style,
    };

    return (
      <div
        className={classnames('Avatar', className)}
        style={styles}
        {...otherProps}
      >
        {this.initials}
      </div>
    );
  }
}

Avatar.propTypes = propTypes;
Avatar.defaultProps = defaultProps;

export default Avatar;
